"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: account/savings-goal-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Faccount%2Fsavings-goal-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavingsGoalServiceClient = exports.SetRoundUpFlagResponse = exports.SetRoundUpFlagRequest = exports.CanCloseSavingsGoalResponse = exports.CanCloseSavingsGoalRequest = exports.GetSuggestedSavingsGoalsResponse = exports.GetSuggestedSavingsGoalsRequest = exports.CloseSavingsGoalResponse = exports.CloseSavingsGoalRequest = exports.UpdateSavingsGoalResponse = exports.UpdateSavingsGoalRequestSetGoal = exports.UpdateSavingsGoalRequest = exports.CreateSavingsGoalResponse = exports.CreateSavingsGoalRequest = exports.CreateSavingsAccountResponse = exports.CreateSavingsAccountRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const account_1 = require("./account");
const image_1 = require("./image");
const shared_savings_goal_1 = require("./shared-savings-goal");
const suggested_saving_goal_1 = require("./suggested-saving-goal");
const protobufPackage = 'com.step.account.proto';
function createBaseCreateSavingsAccountRequest() {
    return { userId: '', currency: '' };
}
exports.CreateSavingsAccountRequest = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.CreateSavingsAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateSavingsAccountRequest();
        message.userId = object.userId ?? '';
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseCreateSavingsAccountResponse() {
    return { account: account_1.Account.fromPartial({}), defaultSavingsGoalId: '' };
}
exports.CreateSavingsAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
            defaultSavingsGoalId: isSet(object.defaultSavingsGoalId)
                ? globalThis.String(object.defaultSavingsGoalId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        if (message.defaultSavingsGoalId !== '') {
            obj.defaultSavingsGoalId = message.defaultSavingsGoalId;
        }
        return obj;
    },
    create(base) {
        return exports.CreateSavingsAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateSavingsAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        message.defaultSavingsGoalId = object.defaultSavingsGoalId ?? '';
        return message;
    },
};
function createBaseCreateSavingsGoalRequest() {
    return {
        primaryAccountId: '',
        title: '',
        goal: undefined,
        iconImage: image_1.SetImage.fromPartial({}),
        coverImage: image_1.SetImage.fromPartial({}),
        currency: '',
        piggyBank: false,
        matching: false,
    };
}
exports.CreateSavingsGoalRequest = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            iconImage: isSet(object.iconImage)
                ? image_1.SetImage.fromJSON(object.iconImage)
                : image_1.SetImage.fromPartial({}),
            coverImage: isSet(object.coverImage)
                ? image_1.SetImage.fromJSON(object.coverImage)
                : image_1.SetImage.fromPartial({}),
        };
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        if (isSet(object.goal)) {
            message.goal = amount_1.Amount.fromJSON(object.goal);
        }
        if (isSet(object.currency)) {
            message.currency = globalThis.String(object.currency);
        }
        if (isSet(object.piggyBank)) {
            message.piggyBank = globalThis.Boolean(object.piggyBank);
        }
        if (isSet(object.matching)) {
            message.matching = globalThis.Boolean(object.matching);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== undefined && message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.goal !== undefined) {
            obj.goal = amount_1.Amount.toJSON(message.goal);
        }
        if (message.iconImage !== undefined) {
            obj.iconImage = image_1.SetImage.toJSON(message.iconImage);
        }
        if (message.coverImage !== undefined) {
            obj.coverImage = image_1.SetImage.toJSON(message.coverImage);
        }
        if (message.currency !== undefined && message.currency !== '') {
            obj.currency = message.currency;
        }
        if (message.piggyBank !== undefined && message.piggyBank !== false) {
            obj.piggyBank = message.piggyBank;
        }
        if (message.matching !== undefined && message.matching !== false) {
            obj.matching = message.matching;
        }
        return obj;
    },
    create(base) {
        return exports.CreateSavingsGoalRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateSavingsGoalRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.title = object.title ?? '';
        message.goal = (object.goal !== undefined && object.goal !== null)
            ? amount_1.Amount.fromPartial(object.goal)
            : undefined;
        message.iconImage = (object.iconImage !== undefined && object.iconImage !== null)
            ? image_1.SetImage.fromPartial(object.iconImage)
            : image_1.SetImage.fromPartial({});
        message.coverImage = (object.coverImage !== undefined && object.coverImage !== null)
            ? image_1.SetImage.fromPartial(object.coverImage)
            : image_1.SetImage.fromPartial({});
        message.currency = object.currency ?? '';
        message.piggyBank = object.piggyBank ?? false;
        message.matching = object.matching ?? false;
        return message;
    },
};
function createBaseCreateSavingsGoalResponse() {
    return { account: account_1.Account.fromPartial({}), subAccountId: '' };
}
exports.CreateSavingsGoalResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
            subAccountId: isSet(object.subAccountId) ? globalThis.String(object.subAccountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        if (message.subAccountId !== '') {
            obj.subAccountId = message.subAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.CreateSavingsGoalResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateSavingsGoalResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        message.subAccountId = object.subAccountId ?? '';
        return message;
    },
};
function createBaseUpdateSavingsGoalRequest() {
    return {
        subAccountId: '',
        title: undefined,
        setGoal: undefined,
        iconImage: undefined,
        coverImage: undefined,
        piggyBank: undefined,
        matchingUpdate: [],
    };
}
exports.UpdateSavingsGoalRequest = {
    fromJSON(object) {
        const message = {
            subAccountId: isSet(object.subAccountId) ? globalThis.String(object.subAccountId) : '',
        };
        if (isSet(object.title)) {
            message.title = globalThis.String(object.title);
        }
        if (isSet(object.setGoal)) {
            message.setGoal = exports.UpdateSavingsGoalRequestSetGoal.fromJSON(object.setGoal);
        }
        if (isSet(object.iconImage)) {
            message.iconImage = image_1.SetImage.fromJSON(object.iconImage);
        }
        if (isSet(object.coverImage)) {
            message.coverImage = image_1.SetImage.fromJSON(object.coverImage);
        }
        if (isSet(object.piggyBank)) {
            message.piggyBank = globalThis.Boolean(object.piggyBank);
        }
        if (globalThis.Array.isArray(object?.matchingUpdate)) {
            message.matchingUpdate = object.matchingUpdate.map((e) => shared_savings_goal_1.MatchingUpdate.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subAccountId !== '') {
            obj.subAccountId = message.subAccountId;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.setGoal !== undefined) {
            obj.setGoal = exports.UpdateSavingsGoalRequestSetGoal.toJSON(message.setGoal);
        }
        if (message.iconImage !== undefined) {
            obj.iconImage = image_1.SetImage.toJSON(message.iconImage);
        }
        if (message.coverImage !== undefined) {
            obj.coverImage = image_1.SetImage.toJSON(message.coverImage);
        }
        if (message.piggyBank !== undefined) {
            obj.piggyBank = message.piggyBank;
        }
        if (message.matchingUpdate?.length) {
            obj.matchingUpdate = message.matchingUpdate.map((e) => shared_savings_goal_1.MatchingUpdate.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSavingsGoalRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSavingsGoalRequest();
        message.subAccountId = object.subAccountId ?? '';
        message.title = object.title ?? undefined;
        message.setGoal = (object.setGoal !== undefined && object.setGoal !== null)
            ? exports.UpdateSavingsGoalRequestSetGoal.fromPartial(object.setGoal)
            : undefined;
        message.iconImage = (object.iconImage !== undefined && object.iconImage !== null)
            ? image_1.SetImage.fromPartial(object.iconImage)
            : undefined;
        message.coverImage = (object.coverImage !== undefined && object.coverImage !== null)
            ? image_1.SetImage.fromPartial(object.coverImage)
            : undefined;
        message.piggyBank = object.piggyBank ?? undefined;
        message.matchingUpdate = object.matchingUpdate?.map((e) => shared_savings_goal_1.MatchingUpdate.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateSavingsGoalRequestSetGoal() {
    return { goal: undefined };
}
exports.UpdateSavingsGoalRequestSetGoal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.goal)) {
            message.goal = amount_1.Amount.fromJSON(object.goal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.goal !== undefined) {
            obj.goal = amount_1.Amount.toJSON(message.goal);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSavingsGoalRequestSetGoal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSavingsGoalRequestSetGoal();
        message.goal = (object.goal !== undefined && object.goal !== null)
            ? amount_1.Amount.fromPartial(object.goal)
            : undefined;
        return message;
    },
};
function createBaseUpdateSavingsGoalResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.UpdateSavingsGoalResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSavingsGoalResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSavingsGoalResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseCloseSavingsGoalRequest() {
    return { subAccountId: '', onlyActiveSubAccounts: false };
}
exports.CloseSavingsGoalRequest = {
    fromJSON(object) {
        const message = {
            subAccountId: isSet(object.subAccountId) ? globalThis.String(object.subAccountId) : '',
        };
        if (isSet(object.onlyActiveSubAccounts)) {
            message.onlyActiveSubAccounts = globalThis.Boolean(object.onlyActiveSubAccounts);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subAccountId !== '') {
            obj.subAccountId = message.subAccountId;
        }
        if (message.onlyActiveSubAccounts !== undefined && message.onlyActiveSubAccounts !== false) {
            obj.onlyActiveSubAccounts = message.onlyActiveSubAccounts;
        }
        return obj;
    },
    create(base) {
        return exports.CloseSavingsGoalRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseSavingsGoalRequest();
        message.subAccountId = object.subAccountId ?? '';
        message.onlyActiveSubAccounts = object.onlyActiveSubAccounts ?? false;
        return message;
    },
};
function createBaseCloseSavingsGoalResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.CloseSavingsGoalResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.CloseSavingsGoalResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseSavingsGoalResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseGetSuggestedSavingsGoalsRequest() {
    return {};
}
exports.GetSuggestedSavingsGoalsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetSuggestedSavingsGoalsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetSuggestedSavingsGoalsRequest();
        return message;
    },
};
function createBaseGetSuggestedSavingsGoalsResponse() {
    return { userGenerated: suggested_saving_goal_1.SuggestedSavingsGoal.fromPartial({}), generic: undefined, suggested: [] };
}
exports.GetSuggestedSavingsGoalsResponse = {
    fromJSON(object) {
        const message = {
            userGenerated: isSet(object.userGenerated)
                ? suggested_saving_goal_1.SuggestedSavingsGoal.fromJSON(object.userGenerated)
                : suggested_saving_goal_1.SuggestedSavingsGoal.fromPartial({}),
            suggested: globalThis.Array.isArray(object?.suggested)
                ? object.suggested.map((e) => suggested_saving_goal_1.SuggestedSavingsGoal.fromJSON(e))
                : [],
        };
        if (isSet(object.generic)) {
            message.generic = suggested_saving_goal_1.SuggestedSavingsGoal.fromJSON(object.generic);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userGenerated !== undefined) {
            obj.userGenerated = suggested_saving_goal_1.SuggestedSavingsGoal.toJSON(message.userGenerated);
        }
        if (message.generic !== undefined) {
            obj.generic = suggested_saving_goal_1.SuggestedSavingsGoal.toJSON(message.generic);
        }
        if (message.suggested?.length) {
            obj.suggested = message.suggested.map((e) => suggested_saving_goal_1.SuggestedSavingsGoal.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetSuggestedSavingsGoalsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSuggestedSavingsGoalsResponse();
        message.userGenerated = (object.userGenerated !== undefined && object.userGenerated !== null)
            ? suggested_saving_goal_1.SuggestedSavingsGoal.fromPartial(object.userGenerated)
            : suggested_saving_goal_1.SuggestedSavingsGoal.fromPartial({});
        message.generic = (object.generic !== undefined && object.generic !== null)
            ? suggested_saving_goal_1.SuggestedSavingsGoal.fromPartial(object.generic)
            : undefined;
        message.suggested = object.suggested?.map((e) => suggested_saving_goal_1.SuggestedSavingsGoal.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCanCloseSavingsGoalRequest() {
    return { subAccountId: '' };
}
exports.CanCloseSavingsGoalRequest = {
    fromJSON(object) {
        const message = {
            subAccountId: isSet(object.subAccountId) ? globalThis.String(object.subAccountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subAccountId !== '') {
            obj.subAccountId = message.subAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.CanCloseSavingsGoalRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCanCloseSavingsGoalRequest();
        message.subAccountId = object.subAccountId ?? '';
        return message;
    },
};
function createBaseCanCloseSavingsGoalResponse() {
    return { closability: account_1.AccountClosability.INVALID_ACCOUNT_CLOSABILITY };
}
exports.CanCloseSavingsGoalResponse = {
    fromJSON(object) {
        const message = {
            closability: isSet(object.closability)
                ? (0, account_1.accountClosabilityFromJSON)(object.closability)
                : account_1.AccountClosability.INVALID_ACCOUNT_CLOSABILITY,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.closability !== account_1.AccountClosability.INVALID_ACCOUNT_CLOSABILITY) {
            obj.closability = (0, account_1.accountClosabilityToJSON)(message.closability);
        }
        return obj;
    },
    create(base) {
        return exports.CanCloseSavingsGoalResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCanCloseSavingsGoalResponse();
        message.closability = object.closability ?? account_1.AccountClosability.INVALID_ACCOUNT_CLOSABILITY;
        return message;
    },
};
function createBaseSetRoundUpFlagRequest() {
    return { subAccountId: '', roundUp: false };
}
exports.SetRoundUpFlagRequest = {
    fromJSON(object) {
        const message = {
            subAccountId: isSet(object.subAccountId) ? globalThis.String(object.subAccountId) : '',
        };
        if (isSet(object.roundUp)) {
            message.roundUp = globalThis.Boolean(object.roundUp);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subAccountId !== '') {
            obj.subAccountId = message.subAccountId;
        }
        if (message.roundUp !== undefined && message.roundUp !== false) {
            obj.roundUp = message.roundUp;
        }
        return obj;
    },
    create(base) {
        return exports.SetRoundUpFlagRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetRoundUpFlagRequest();
        message.subAccountId = object.subAccountId ?? '';
        message.roundUp = object.roundUp ?? false;
        return message;
    },
};
function createBaseSetRoundUpFlagResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.SetRoundUpFlagResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.SetRoundUpFlagResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetRoundUpFlagResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
class SavingsGoalServiceClient {
    rpc;
    name = 'com.step.account.proto.SavingsGoalService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/account';
    methods = [{
            name: 'CreateSavingsAccount',
            requestType: exports.CreateSavingsAccountRequest,
            responseType: exports.CreateSavingsAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateSavingsGoal',
            requestType: exports.CreateSavingsGoalRequest,
            responseType: exports.CreateSavingsGoalResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateSavingsGoal',
            requestType: exports.UpdateSavingsGoalRequest,
            responseType: exports.UpdateSavingsGoalResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CloseSavingsGoal',
            requestType: exports.CloseSavingsGoalRequest,
            responseType: exports.CloseSavingsGoalResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CanCloseSavingsGoal',
            requestType: exports.CanCloseSavingsGoalRequest,
            responseType: exports.CanCloseSavingsGoalResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetSuggestedSavingsGoals',
            requestType: exports.GetSuggestedSavingsGoalsRequest,
            responseType: exports.GetSuggestedSavingsGoalsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetRoundUpFlag',
            requestType: exports.SetRoundUpFlagRequest,
            responseType: exports.SetRoundUpFlagResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Create a new savings account with a default savings goal.
     */
    createSavingsAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Create a new savings goal sub-account for the user.
     */
    createSavingsGoal(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update the details for an existing sub-account for the user.
     */
    updateSavingsGoal(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Close a user's savings goal sub-account.
     */
    closeSavingsGoal(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Whether the savings goal can be closed or not.
     */
    canCloseSavingsGoal(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get details of the suggested savings goals to display to users when they
     * are creating a new savings goal.
     */
    getSuggestedSavingsGoals(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set round-up flag for savings goal.
     */
    setRoundUpFlag(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.SavingsGoalServiceClient = SavingsGoalServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=savings-goal-service.js.map